import React, { useState, useCallback } from 'react';
import { useSnackbarMessage } from '../SnackMessge.tsx';
import * as columns from '../../misc/Columns';
import { Dialog, Button, DialogActions } from '@mui/material';
import { NewOrEdit } from '../NewOrEdit.tsx';

type EditDataType = { [key: string]: any };
type LOVType = { [key: string]: string[] | { [key: string]: string } };

interface EditDialogProps {
    columns: columns.ColumnInfo[];
    lovs: LOVType;
    initialEditData: EditDataType;
    onClose: () => void;
    onUpdated: (data: EditDataType) => Promise<void>;
}

export function EditDialog({
    columns,
    lovs,
    onClose,
    onUpdated,
    initialEditData
}: EditDialogProps): JSX.Element {

    const [editData, setEditData] = useState<EditDataType>(initialEditData);
    const { showMessage } = useSnackbarMessage();

    const handleClose = useCallback(() => {
        onClose();
    }, [onClose]);

    const handleUpdate = useCallback(async () => {
        try {
            await onUpdated(editData);
            setEditData(initialEditData);
            handleClose();
        } catch (error) {
            console.error("Error updating record:", error);
            showMessage("Error updating record. Please try again.");
        }
    }, [onUpdated, editData, handleClose, showMessage, initialEditData]);

    const handleChangedData = useCallback((data: EditDataType) => {
        setEditData(data);
    }, [setEditData]);

    const filteredColumns = getColumns(columns);

    return (
        <Dialog onClose={handleClose} open={true} fullWidth={true} maxWidth="lg">
            <NewOrEdit rowData={editData} columns={filteredColumns} changedData={handleChangedData} lovs={lovs} />
            <DialogActions>
                <Button onClick={handleClose}>Close</Button>
                <Button onClick={handleUpdate} autoFocus>
                    Update
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function getColumns(columns: columns.ColumnInfo[]): columns.ColumnInfo[] {
    return columns
        .map(col => ({ ...col, hidden: col.id === 'id' ? true : col.hidden })) // Use existing hidden property
        .filter(col => col.type !== 'action');
}